/* Auto Generated */

export enum OAuthProviderType {
    unknown,
    google,
}
